import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { SubjectRelay } from '../../commands/subject-relay.class';

import { FiltrableSelectComponentBase } from './filterable-select.component-base';

@Component({
	selector: 'no-input-reset-filterable-select',
	templateUrl: 'no-input-reset-filterable-select.html',
	styleUrls: ['no-input-reset-filterable-select.css'],
})
export class NoInputResetFilterableSelectComponent extends FiltrableSelectComponentBase<any> {
	constructor() {
		super();

		// Definit comment le filtrage est effectue
		this.filteredItems$ = combineLatest([this.textFilter$, this.list$, this.reset$]).pipe(
			map(
				([filter, list, _]) => {
					if (!list) {
						return [];
					}
					
					if (!filter) {
						return [...list];
					}

					let normalizedFilter = this.normalizeValue(filter);
					return list.filter(
						(item) => {
							let label: string | undefined = this.getLabel(item);
							let normalizedLabel: string = this.normalizeValue(label);
							return normalizedLabel.includes(normalizedFilter);
						}
					);
				}
			)
		);
		
		this.initialValueSubject.subscribe(
			(initialValue: string | null) => {
				this.filterInput.setValue(initialValue ? initialValue : '');
			}
		);
	}

	// La class de style a appliquer au composant de saisie
	@Input() inputClass: string = '';
	
	@Input() maxLength: number = 128;
	
	private initialValueSubject = new SubjectRelay<string | null>();
	@Input() set initialValue(obs: Observable<string | null> | undefined) {
		this.initialValueSubject.registerSource(obs);
	}

	// L'evenement necessaire au two-way binding pour la valeur saisie dans le champ
	@Output() change = new EventEmitter<any>();
	
	protected override resetInputValueToSelectedItem() {
		// Ce composant ne reset pas la valeur du champ quand l'utilisateur sort du dit champ
		// A la place, il emet la valeur actuelle en direction du parent
		//
		// NB: l'emploi d'un suggestable-input serait peut-être preferable a ceci dans la majorité des cas
		this.change.emit(this.filterInput.value);
	}
}